import { NativeMockBackground } from '../../widgets/NativeMockBackground';
import { InstallCard } from './components/InstallCard';

export function PwaInstallChrome() {
  return (
    <NativeMockBackground>
      <InstallCard />
    </NativeMockBackground>
  );
}
